__turbopack_context__.v({
  "chevron": "index-module-scss-module__0M5TuG__chevron",
  "content": "index-module-scss-module__0M5TuG__content",
  "item": "index-module-scss-module__0M5TuG__item",
  "toggle": "index-module-scss-module__0M5TuG__toggle",
});
